import { Env } from "@/env.mjs"
import { ZodError } from "zod"

const dummyLogger = {
    log: () => {},
    error: () => {},
    warn: () => {},
    info: () => {},
    debug: () => {},
    group: () => {},
    groupEnd: () => {},
    groupCollapsed: () => {},
    dir: () => {},
} as unknown as typeof console

/**
 * Logger service that prints messages to the console
 * only in development mode
 */
export const logger = Env.NEXT_PUBLIC_DISABLE_CONSOLE_LOG
    ? dummyLogger
    : console

interface FormattedZodError {
    path: string
    message: string
}

function formatZodError(error: ZodError): FormattedZodError[] {
    return error.errors.map((err) => ({
        path: err.path.join("."),
        message: err.message,
    }))
}

export function logZodErrors(error: ZodError, originalData?: unknown): void {
    const formattedErrors = formatZodError(error)

    logger.groupCollapsed(
        "%c❌ Zod Validation Errors:",
        "color: red; font-weight: bold;",
    )
    formattedErrors.forEach((err) => {
        logger.log(
            `%c🔸 Path: %c${err.path || "root"}\n   %cMessage: %c${err.message}`,
            "color: orange; font-weight: bold;", // Path label
            "color: white;", // Path value
            "color: cyan; font-weight: bold;", // Message label
            "color: white;", // Message value
        )
    })

    if (originalData) {
        logger.groupCollapsed(
            "%c📂 Original Data (click to expand)",
            "color: gray; font-style: italic;",
        )
        logger.dir(originalData)
        logger.groupEnd()
    }

    logger.groupEnd()
}
